// The pressure reading is an unsigned 12-bit integer value. The integer value is converted to pressure in Pascals (Pa) using the ConversionFormulaScale and ConversionFormulaOffset parameters. Convert the 12-bit integer value ($rdg in code below) to Pascals ($prs in code below) using the following algorithm:

/*
$prs = 0.0;

if ( $rdg == 0xFFF ) {
  $prs = null; // display reading as “invalid”
} else {
  $kfactor = (float)$ConversionFormulaScale;
  $offset = (float)$ConversionFormulaOffset;
  $val = ($rdg * $kfactor) + $offset;

  if ( $val > 0.0 ) {
    $prs = $val;
  }
}

*/

export function pressure(
  reading: number,
  scale: number,
  offset: number,
  frequency: number
): number {
  const kfactor = scale
  const pressure = reading * kfactor + offset

  if (pressure > 0.0) {
    return pressure
  }

  return 0
}
